import moment from "moment"
import Colors from "../../../constants/Colorsv2"
import { LineDataProps } from "../../../store/types/analytics_svc"
import { BestAvailableOrderProps, MarketProps, OrderProps, TradeProps } from "../../../store/types/mk_svc"


export const trade_getOrderFromTrade = (trade:TradeProps, unit_size?:number):OrderProps => {
    let open_amt = 10
    if(unit_size){ open_amt = unit_size }
    let draft_liquidity = 0
    if(trade.draft_liquidity){ draft_liquidity = trade.draft_liquidity }

    return {
        order_id: '',
        player_id: '',
        be_type: 'market', //TODO - Make this dynamic,
        open_amt,
        called_amt: 0,
        buy_sell_ind: 'buy',
        available_for_parlays: false,
        event_id: trade.event_id,
        draft_liquidity,
        event_type: trade.event_type,
        side: trade.side as 'home'|'away'|'over'|'under'|'yes'|'no',
        side_type: trade.side_type,
        resolution_status: 'inprogress',
        side_id: trade.side_id,
        order_type: trade.limit_override ? 'limit': 'market',
        potential_winnings: 0,
        collar_pct: .01,
        positions: [],
        market_id: trade.market_id,
        title: '',
        probability: trade.probability,
        odds: trade.odds,
        var_1: trade.var_1,
        market_type: trade.market_type,
        position_ids: [],
        status: 'approved',
        expire_datetime: moment().add(1, 'hours')
    }
}

export const trade_getTradeFromAvailableOrder = (ba:BestAvailableOrderProps):TradeProps => {
    return {
        trade_id:'',
        event_id: ba.event_id,
        event_type: ba.event_type as 'tournament'|'team'|'match',
        cumulative_amt: 0,
        trade_amt: 0,
        create_datetime: '', last_update_datetime: '',
        market_id: ba.market_id,
        var_1: ba.var_1,
        side: ba.side,
        side_id: ba.side_id,
        draft_liquidity: ba.open_amt,
        reversed_side_id: '',
        probability: ba.probability,
        odds: ba.odds,
        side_type: ba.side_type as 'team'|'athlete'|'event',
        market_type: 'FOR_MONEY',
        latest: true,
        position_ids: []
    }
}

export const trade_getTradeFromMarket = (market:MarketProps, side:string, side_id:string, event_id:string, event_type: 'match'|'tournament'|'team'):TradeProps => {
    let side_option = market.side_options.find(o => o.side == side)
    return {
        trade_id:'',
        event_id,
        event_type,
        trade_amt: 0,
        cumulative_amt: 0,
        latest:true,
        probability:0.5,
        odds: 100,
        create_datetime:'',
        last_update_datetime: '',
        market_id: market.market_id,
        var_1: 0,
        side_id,
        side_type:side_option?.id_source??'team',
        side,
        position_ids:[],
        market_type: 'FREE'
    }
}



export const trade_getLineChartData = (trades:TradeProps[]):LineDataProps[] => {

    let tradeData:LineDataProps[] = []
    trades.sort((a,b) => moment(a.create_datetime).unix() - moment(b.create_datetime).unix()).map(t => {
        tradeData.push(
            {
                name: moment(t.create_datetime).format('hh:ss a'),
                data: [
                    {
                    label: 'Probability',
                    amt: t.probability*100,
                    color:Colors.brand.midnight
                }]
            }
        )
    })
    return tradeData
}


export const trade_reverseTradeSide = (trade?:TradeProps, market?:MarketProps):TradeProps | undefined => {
    if(!market){ return undefined }
    if(!trade){ return undefined }
    let o_side = market.side_options.find(o => o.side !== trade.side)
    if(!o_side){ throw new Error('Invalid reverse') }
    trade = { ...trade, side:o_side.side as string, odds: trade.odds * -1, probability: 1 - trade.probability, side_id: trade.reversed_side_id, reversed_side_id:trade.side_id }
    if(market.type === 'Spread'){
        trade.var_1 = trade.var_1 * -1
    }
    return trade
}